const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.hamburgerActive();
        this.subMenu();
        if($(window).width() < 1200) {
            $('.menu-item-has-children > a').append(`<svg class="menu-arrow" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15.475C11.8667 15.475 11.7373 15.45 11.612 15.4C11.4867 15.35 11.3827 15.2833 11.3 15.2L6.7 10.6C6.51667 10.4167 6.425 10.1833 6.425 9.9C6.425 9.61667 6.51667 9.38334 6.7 9.2C6.88334 9.01667 7.11667 8.925 7.4 8.925C7.68334 8.925 7.91667 9.01667 8.1 9.2L12 13.1L15.9 9.2C16.0833 9.01667 16.3167 8.925 16.6 8.925C16.8833 8.925 17.1167 9.01667 17.3 9.2C17.4833 9.38334 17.575 9.61667 17.575 9.9C17.575 10.1833 17.4833 10.4167 17.3 10.6L12.7 15.2C12.6 15.3 12.4917 15.371 12.375 15.413C12.2583 15.455 12.1333 15.4757 12 15.475Z" fill="black"/>
            </svg>`);
        } else {
            $('.menu-item-has-children > a').append('<img class="menu-arrow" src="' + theme.arrow_down + '">');
        }
    },

    hamburgerActive: function() {
        $(".hamburger").on('click', function() {
            $(".hamburger").toggleClass("hamburger-active");
            $(".site-header").toggleClass("site-header-open");
            $('body').toggleClass("body-hidden");
        });
    },

    subMenu: function() {
        if($(window).width() < 1200)
        {
            $(document).on('click', '.menu-arrow', function(e) {
                e.preventDefault();
                console.log(e.target);
                
                // Toggle the visibility of the submenu
                $(this).parent().next('.sub-menu').slideToggle();
            });
        }
        $( ".menu-arrow" ).on('click', function() {
            $( ".menu-item-has-children" ).removeClass( "open" );
            $('.sub-menu').slideUp();
            $( this ).parent().addClass( "open" ).find( ".sub-menu" ).slideDown();
        });
        $( ".menu-arrow" ).on('click', function() {
            $( ".menu-item-has-children" ).removeClass( "open" );
            $('.sub-menu').slideUp();
        });
    }
}

export default _this;